import React from "react";
import SupportCollege from "./SupportCollege";

const SupportStudent = () => {
  return <SupportCollege userType="student" />;
};

export default SupportStudent;
